import { Box, Button, Svg, SvgBubble, Tooltip } from '@hopskipdrive/react-components';

interface useTableActionsProps {
  user: User | null | undefined;
  handleSnoozeAlert: (id: string) => void;
  setCloseAlertId: (id: number | undefined) => void;
  setCloseAlertType: (type: string) => void;
}

export const useTableActions = ({
  user,
  handleSnoozeAlert,
  setCloseAlertId,
  setCloseAlertType,
}: useTableActionsProps) => {
  const closableTypes = ['extreme_lateness'];

  return [
    {
      label: 'Actions',
      align: 'center' as const,
      valueGetter: ({ id, state, assigneeId, highPriority, incidentType }) => {
        const isAssignedToUser = assigneeId === user?.id;

        return (
          isAssignedToUser && (
            <Box display="flex" alignItems="center" gap="4px">
              {state !== 'snoozed' && (
                <Button color="tonal variant" data-testid={`snooze-btn-${id}`} onClick={() => handleSnoozeAlert(id)}>
                  Snooze
                </Button>
              )}
              {(state === 'open' || state === 'accepted') && (highPriority || closableTypes.includes(incidentType)) && (
                <Box display="flex" alignItems="center" gap="4px">
                  <Button
                    data-testid={`close-alert-btn-${id}`}
                    onClick={() => {
                      setCloseAlertId(id);
                      setCloseAlertType(incidentType);
                    }}
                    style={{
                      backgroundColor: 'rgba(255, 218, 212, 1)',
                      border: 'none',
                      color: 'rgba(221, 55, 48, 1)',
                    }}
                  >
                    Close
                  </Button>
                  <Tooltip title="Close/Resolve this alert. You will be asked to provide a reason in the pop-up modal.">
                    <SvgBubble style={{ backgroundColor: 'rgba(255, 218, 212, 1)' }}>
                      <Svg icon="info" style={{ marginRight: 0 }} />
                    </SvgBubble>
                  </Tooltip>
                </Box>
              )}
            </Box>
          )
        );
      },
      minWidth: '100px',
      maxWidth: '250px',
    },
  ];
};
